<template>
  <div class="common-table">
    <a-table
      :columns="columns"
      :data-source="data ? data : []"
      :loading="loading"
      :rowKey="(record, index) => index"
      :rowClassName="addClassName"
      :pagination="tablePagination"
      @change="handleTableChange"
      size="middle"
    >
      <!-- 전체 체크 -->
      <template v-slot:checkboxAll>
        <a-checkbox
          :checked="checkAll"
          :indeterminate="indeterminate"
          @change="onCheckAllChange"
        ></a-checkbox>
      </template>

      <!-- 단일 체크 -->
      <template v-slot:checkbox="{ record }">
        <a-checkbox
          :checked="checkedList.indexOf(record[target]) > -1"
          @change="(e) => onCheckboxChange(e, record)"
          :disabled="record.isEnable === 0"
        ></a-checkbox>
      </template>

      <!-- 라디오 버튼 -->
      <template v-slot:radiobutton="{ record }">
        <a-radio
          v-model="radioValue"
          :checked="radioValue === record[target]"
          @change="() => onRadioChange(record)"
          :disabled="record.isEnable === 0"
        />
      </template>

      <!-- 년월일 -->
      <template v-slot:date="{ text }">
        <span v-if="text">{{ common.timeFormatFromUTCEpoch(text, 3) }}</span>
        <span v-else>-</span>
      </template>

      <!-- 년월일 시분초 -->
      <template v-slot:dateTime="{ text }">
        <span v-if="text">{{ common.timeFormatFromUTCEpoch(text, 1) }}</span>
        <span v-else>-</span>
      </template>

      <!-- 라이센스 타입 -->
      <template v-slot:licenseType="{ text }">
        <span v-if="text === 1">{{$t("LC_Modal_LicenseList1")}}</span>
        <span v-else-if="text === 2">{{$t("LC_Modal_LicenseList2")}}</span>
        <span v-else-if="text === 4">{{$t("LC_Modal_LicenseList3")}}</span>
        <span v-else>-</span>
      </template>

      <!-- 인원 수(명) -->
      <template v-slot:persons="{ text }">
        <span v-if="text">{{ text }}{{$t("Common_people")}}</span>
        <span v-else>-</span>
      </template>

      <!-- 설정 메뉴 -->
      <template v-slot:settingTitle>
        <SettingFilled />
      </template>

      <!-- 설정 내용 -->
      <template v-slot:settingIcon="{ record }">
        <TemplateSettingMenu
          v-if="settingType === 'template'"
          :record="record"
        />
        <UserSettingMenu v-if="settingType === 'user'" :record="record" />

        <SampleSettingMenu
          v-if="settingType === 'attachSample'"
          :record="record"
        />

        <AttachFileSettingMenu
          v-if="settingType === 'attachFile'"
          :record="record"
        />
      </template>

      <!-- 훈련 유형 -->
      <template v-slot:examType="{ text }">
        <span v-if="text === 1">
          <a-tag class="color-temp-warning">{{$t("Common_Attach_txt")}}</a-tag>
        </span>
        <span v-else-if="text === 4">
          <a-tag class="color-temp-phishing">{{$t("Common_Phishing_txt")}}</a-tag>
        </span>
        <span v-else>-</span>
      </template>

      <!-- 템플릿 카테고리 -->
      <template v-slot:examCategory="{ text }">
        <span v-if="text === 1">{{$t("TP_Edit_1_Category_Selec2")}}</span>
        <span v-else-if="text === 2">{{$t("TP_Edit_1_Category_Selec3")}}</span>
        <span v-else-if="text === 3">{{$t("TP_Edit_1_Category_Selec4")}}</span>
        <span v-else-if="text === 4">{{$t("TP_Edit_1_Category_Selec5")}}</span>
        <span v-else-if="text === 5">{{$t("TP_Edit_1_Category_Selec6")}}</span>
        <span v-else>{{$t("TP_Edit_1_Category_Selec1")}}</span>
      </template>

      <!-- 템플릿 언어 -->
      <template v-slot:language="{ text }">
        <span v-if="text === 1">{{$t("TP_Edit_1_Language_selec2")}}</span>
        <span v-else-if="text === 2">{{$t("TP_Edit_1_Language_selec3")}}</span>
        <span v-else-if="text === 3">{{$t("TP_Edit_1_Language_selec4")}}</span>
        <span v-else>{{$t("TP_Edit_1_Language_selec1")}}</span>
      </template>

      <!-- 템플릿 업데이트 -->
      <template v-slot:update="{ text }">
        <span v-if="text === 1">{{$t("TP_Edit_1_Update_Box1")}}</span>
        <span v-else>{{$t("TP_Edit_1_Update_Box2")}}</span>
      </template>

      <!-- 공개 여부 -->
      <template v-slot:ox="{ text }">
        <span v-if="text === 1">O</span>
        <span v-else>-</span>
      </template>

      <!-- 사용자 권한 -->
      <template v-slot:userType="{ text }">
        <span v-if="text === 1000">{{$t("User_Add6")}}</span>
        <span v-else-if="text === 100">{{$t("User_Add5")}}</span>
        <!-- <span v-else-if="text === 10">유저</span> -->
        <span v-else>{{$t("User_Add4")}}</span>
      </template>

      <!-- 파일 확장자 -->
      <template v-slot:fileExt="{ record }">
        <span>{{ record.fileName.split(".")[1] }}</span>
      </template>

      <!-- 첨부파일 유형 -->
      <template v-slot:attachCategory="{ text }">
        <span v-if="text === 1">
          <a-tag class="color-attach-exe">{{$t("Attach_Upload13")}}</a-tag>
        </span>
        <span v-else-if="text === 2">
          <a-tag class="color-attach-lnk">{{$t("Attach_Upload15")}}</a-tag>
        </span>
        <span v-else-if="text === 3">
          <a-tag class="color-attach-doc">{{$t("Attach_Upload16")}}</a-tag>
        </span>
        <span v-else-if="text === 4">
          <a-tag class="color-attach-html">{{$t("Attach_Upload17")}}</a-tag>
        </span>
        <span v-else>-</span>
      </template>

      <!-- 첨부 훈련 유형 -->
      <template v-slot:attachExamType="{ text }">
        <span v-if="text === 1">
          <a-tag class="color-temp-warning">{{$t("Common_attach_title1")}}</a-tag>
        </span>
        <span v-else-if="text === 2">
          <a-tag class="color-temp-file">{{$t("Common_Mok_txt")}}</a-tag>
        </span>
        <span v-else-if="text === 3">
          <a-tag class="color-temp-research">{{$t("Common_attach_title6")}}</a-tag>
        </span>
        <span v-else-if="text === 4">
          <a-tag class="color-temp-phishing">{{$t("TP_Edit_1_ExamType_Title4")}}</a-tag>
        </span>
        <span v-else>-</span>
      </template>

      <!-- 첨부 아이콘 -->
      <template v-slot:fileIcon="{ record }">
        <img
          class="attach-fileIcon"
          :src="`/fdata/attachFile/${record.attachInfoNo}/${record.fileIcon}`"
        />
      </template>

      <!-- 첨부 부가기능 -->
      <template v-slot:attachFunction="{ text }">
        <span v-if="Object.keys(text).length > 0">
          <a-tag
            v-for="(value, key) in text"
            :key="key"
            class="color-bg-attachFunction"
            >{{ key.toUpperCase() }}</a-tag
          >
        </span>
        <span v-else>-</span>
      </template>

      <!-- 첨부 제약사항 -->
      <template v-slot:attachRestrict="{ text }">
        <span v-if="Object.keys(text).length > 0">
          <a-tag
            v-for="(value, key) in text"
            :key="key"
            class="color-bg-attachRestrict"
            >{{ key.toUpperCase() }}</a-tag
          >
        </span>
        <span v-else>-</span>
      </template>
    </a-table>
  </div>
</template>

<script>
import {
  computed,
  onBeforeMount,
  onMounted,
  onUpdated,
  reactive,
  ref,
  toRefs,
  watchEffect,
  watch,
} from "vue";
import { SettingFilled } from "@ant-design/icons-vue";
import * as common from "@/utils/common";
import TemplateSettingMenu from "@/components/sideComponents/TemplateSettingMenu";
import UserSettingMenu from "@/components/sideComponents/UserSettingMenu";
import SampleSettingMenu from "@/components/sideComponents/SampleSettingMenu";
import AttachFileSettingMenu from "@/components/sideComponents/AttachFileSettingMenu";
import { useStore } from "vuex";

export default {
  name: "CommonTable",
  props: {
    // required
    data: Array,
    columns: Array,
    loading: Boolean,
    // options
    pagination: Object,
    handleTableChange: Function, // 페이지 변경 이벤트
    useSelection: Boolean, // 체크박스 사용 여부
    handleSelect: Function, // 체크박스 선택 이벤트
    target: String, // 체크박스 선택값
    settingType: String, // 테이블 내의 설정(수정,삭제) 모달 구분값
  },
  components: {
    TemplateSettingMenu,
    UserSettingMenu,
    SampleSettingMenu,
    SettingFilled,
    AttachFileSettingMenu,
  },
  setup(props) {
    const store = useStore();

    const state = reactive({
      checkAll: false,
      indeterminate: false,
      checkedList: [],
      checkItem: false,
      radioValue: null,
      tablePagination: props.pagination ? props.pagination : {},
    });

    onMounted(() => {
      // 화면 사이즈(높이)에 해당하는 테이블 리스트의 개수 설정
      let fitRowCount = Math.trunc((window.innerHeight - 300) / 45);
      if (!props.pagination) {
        state["tablePagination"]["pageSize"] =
          fitRowCount < 5 ? 5 : fitRowCount;
      }
    });

    // 체크 가능한 리스트
    const enableList = computed(() => {
      return props.useSelection
        ? props.data
            .filter((item) => item.isEnable === 1)
            .map((value) => value[props.target])
        : [];
    });

    // 전체 체크박스 선택/해제
    const onCheckAllChange = (e) => {
      const { checkedList, checkAll } = state;

      if (e.target.checked) {
        state["checkAll"] = true;
        state["checkedList"] = enableList.value.slice();
      } else {
        state["checkAll"] = false;
        state["checkedList"] = [];
      }
      state["indeterminate"] = false;

      props.handleSelect(state["checkedList"]);
    };

    // 단일 체크박스 선택/해제
    const onCheckboxChange = (e, record) => {
      const { checkedList } = state;

      let targetNo = record[props.target];
      if (checkedList.indexOf(targetNo) > -1) {
        state["checkedList"].splice(checkedList.indexOf(targetNo), 1);
      } else {
        state["checkedList"].push(targetNo);
      }

      state["indeterminate"] =
        checkedList.length && checkedList.length < enableList.value.length;
      state["checkAll"] = checkedList.length === enableList.value.length;

      props.handleSelect(state["checkedList"]);
    };

    // 삭제 표시
    const addClassName = (record, index) => {
      if (record.isEnable === 0) return "delete-item";
    };

    // 라디오 버튼 이벤트
    const onRadioChange = (record) => {
      state["radioValue"] = record[props.target];
      props.handleSelect(state["radioValue"]);
    };

    return {
      ...toRefs(state),
      common,
      addClassName,
      onCheckAllChange,
      onCheckboxChange,
      onRadioChange,
    };
  },
};
</script>